import Get from '../services/Get';
import Put from '../services/Put';
import { nexcareVersion } from '../config/serviceConfig';

const getTNC = (token) => Get(`/${nexcareVersion}/nexcare/tnc`, token);
const putAcceptTNC = (data, token) => Put(`/${nexcareVersion}/nexcare/tnc/accept`, data, token);

const API_TNC = {
    getTNC,
    putAcceptTNC,
}

export default API_TNC